import React from 'react';

import clsx from 'clsx';
import { ReactComponent as HistoricalEventsBackground } from 'PDF/assets/images/HistoricalEventsBackground.svg';
import { getColorType } from 'PDF/helpers/documentStyle';

import { Bookmark } from './Bookmark';
import { Timeline } from './Timeline';

export interface IEvent {
  step: string;
  title: string;
}

interface IVerticalTimelineProps {
  data: IEvent[];
}

export const VerticalTimeline: React.FC<IVerticalTimelineProps> = ({ data }) => (
  <div className={clsx('container', getColorType())}>
    <div className="background-image">
      <HistoricalEventsBackground />
    </div>
    <Timeline className="my-vertical-progress">
      {data?.map((date, index) => (
        <Bookmark
          key={index}
          className={
            index === data.length - 1
              ? (index + 1) % 2 == 1
                ? 'last-timeline-item-odd'
                : 'last-timeline-item-even'
              : ''
          }
        >
          <h1 className="step">{date.step}</h1>
          <p className="description">{date.title}</p>
        </Bookmark>
      ))}
    </Timeline>
  </div>
);
